import { createApiInstance } from './config'

const api = createApiInstance()

export const desktopLicenseAPI = {
  list(page = 1, pageSize = 20, keyword = null, status = null) {
    const params = { page, pageSize }
    if (keyword != null && String(keyword).trim()) {
      params.keyword = String(keyword).trim()
    }
    if (status != null && String(status).trim()) {
      params.status = String(status).trim()
    }
    return api.get('/desktop-licenses', { params })
  },

  issue(days, count) {
    return api.post('/desktop-licenses/issue', { days, count })
  },

  unbind(id) {
    return api.post(`/desktop-licenses/${id}/unbind`)
  },

  disable(id) {
    return api.post(`/desktop-licenses/${id}/disable`)
  },

  enable(id) {
    return api.post(`/desktop-licenses/${id}/enable`)
  },

  delete(id) {
    return api.delete(`/desktop-licenses/${id}`)
  }
}

export default desktopLicenseAPI
